/*
Sohel        09/21/2022  2698821717 Fixed Client Maintainance Bugs
Saikrishna   10/07/2022  2698821717 Fixed jira bugs role and client maintenance
Ashraf       10/10/2022  2698821717 fixed tooltip for current rate popup in client maintenance, redirect when access is not given
saimaheshwar 10/13/2022  2698821717 fix UI layout issue in client dashboard table
saimaheshwar 10/20/2022  2698821717 fixed client maintenance UI issues
Sai Maheshwar 20-10-2022 2698821717 fixed client maintenance dashboard UI
 Suresh Peddavoora 10/30/2022 2698821717 Added Buttons in Toolbar section in table
 Suresh Peddavoora 10/31/2022 2698821717 Removed card styles for Table
 dilip 11/01/2022 2698821717 Removed advance search button
saikrishna 11/04/2022 2698821717 changed the paginationOptions
akhila 11/03/2022 2698821717 TablePagination bugFix
Ashraf 11/14/2022 2698821717 moved search form into div
akhila 11/03/2022 2698821717 TablePagination bugFix
Raghu 11/14/2022 2698821717 Table card style fixes
Ashraf 11/15/2022 2698821717 fixed role based bugs

 */
import React, {useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../components/TableIcons';
import {fetchClientData} from '../../../redux/reducers/ClientDashboard';
import DetailPanel from './SearchDeashboardDetailPanel';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import {useUpdateEffect} from 'react-use';
import {useHistory} from 'react-router';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {Button, TablePagination} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {tablePageRows} from '../../../constants/ReusableConstants';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import SearchForm from './SearchForm';

// Client maintenance Main Dashboard Table component
export default function SearchDashboardTable({
  advancedSearchData,
  search,
  handleSearch,
  setSearchedData,
  setSubmit,
  clear,
  setClear,
  setAdvancedSearchData,
}) {
  const history = useHistory();
  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();
  const {searchAny, searchText, setJustClientAdded, justClientAdded} =
    useContext(SelectTabContextProvider);
  const data = {
    parentClientName: '',
    clientName: '',
    searchBy: searchAny.key ? searchAny.key : '',
    searchTerm: searchText ? searchText : '',
    clientPrefix: '',
  };

  const tableRef = useRef(0);
  // For Displaying proper toast messages and maintain Refresh table when required
  useEffect(() => {
    if (justClientAdded) {
      dispatch(fetchClientData(data));
      setTimeout(() => {
        setJustClientAdded(false);
      }, 1500);
    }
  }, [justClientAdded]);
  useUpdateEffect(() => {
    if (!search) {
      const data = {
        parentClientName: '',
        clientName: '',
        searchBy: '',
        searchTerm: '',
        clientPrefix: '',
      };
      dispatch(fetchClientData(data));
    }
  }, [search]);

  const {clientData, isLoading} = useSelector(({dashboardClient}) => dashboardClient);
  const {roleData} = useSelector(({role}) => role);

  const disabledByRole = roleData?.window?.['Client Maintenance'];
  const columns = [
    {
      title: 'Parent Client',
      field: 'parentClientName',
      customSort: (a, b) => {
        if (a.parentClientName < b.parentClientName) {
          return -1;
        }
        if (a.parentClientName > b.parentClientName) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: 'Client Name',
      field: 'clientName',
    },
    {
      title: 'Client Prefix',
      field: 'clientId',
    },
  ];

  // For Refactoring Table data came from API as per current table
  const getClientData =
    clientData?.length > 0 ?
      clientData?.map((item) => {
        return {
          parentClientName: item?.parentClientName,
          parentClientId: item?.parentClientId,
          clientId: item?.clientId,
          clientName: item?.clientName,
          subscribedServices:
            item?.subscribeServices && item?.subscribeServices?.clientNumber ?
              [...item?.subscribeServices, {clientId: item?.subscribeServices?.clientNumber}] :
              item?.subscribeServices ?
                [...item?.subscribeServices] :
                [],
          unSubscribedServices: item?.unsubscribedServiceResponse ?
            item?.unsubscribedServiceResponse :
            [],
          terminatedServices: item?.inActiveSubscribedServices ?
            item?.inActiveSubscribedServices :
            [],
        };
      }) :
      [];
  return (
    <>
      <div>
        <div className="custom-table client-dashboard-table">
          <>
            <SearchForm
              handleSearch={handleSearch}
              setSearchedData={setSearchedData}
              setSubmit={setSubmit}
              clear={clear}
              setClear={setClear}
              setAdvancedSearchData={setAdvancedSearchData}
            />
            <GuiTable
              title={''}
              tableRef={tableRef}
              columns={columns}
              isLoading={isLoading}
              icons={tableIcons}
              detailPanel={[
                {
                  tooltip: 'Show Data',
                  render: (rowData) => {
                    if (tableRef.current.dataManager !== null) {
                      tableRef.current.dataManager.detailPanelType = 'single';
                    }
                    return (
                      <DetailPanel
                        rowData={rowData}
                        advancedSearchData={advancedSearchData}
                      />
                    );
                  },
                },
              ]}
              data={getClientData}
              options={{
                search: false,
                sorting: true,
                toolbarButtonAlignment: 'left',
                thirdSortClick: true,
                pageSizeOptions: tablePageRows,
                pageSize: rows,
                emptyRowsWhenPaging: false,
                detailPanelType: 'single',
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              components={{
                Pagination: (props) => (
                  <div className="global-field-table-footer ">
                    <div className="mt-2">

                    </div>
                    <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                      <TablePagination
                        {...props}
                        SelectProps={{
                          inputProps: {'aria-label': 'Rows per screen'},
                        }}
                        labelRowsPerPage={'Rows per screen:'}
                        rowsPerPageOptions={tablePageRows}
                        onChangeRowsPerPage={(event) => {
                          props.onChangeRowsPerPage(event);
                          setRows(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                ),
              }}
              actions={[
                {
                  icon: () => (
                    <>
                      <div>
                        <Button
                          variant="outlined"
                          size="large"
                          className={`mx-1  search-btn`}
                          onClick={() => history.push('/parent-client')}
                          disabled={!roleData?.window?.['Client Maintenance']?.PC?.read}
                        >
            Parent Client
                        </Button>
                      </div>
                    </>
                  ),
                  isFreeAction: true,
                  onClick: () => history.push('/parent-client'),
                },
                {
                  icon: () => (
                    <>
                      <div>
                        <Button
                          variant="outlined"
                          size="large"
                          className={`mx-1  search-btn`}
                          onClick={() => history.push('/client-form')}
                          disabled={!disabledByRole?.AC?.add}
                        >
                          <AddIcon />
            Add Client
                        </Button>
                      </div>
                    </>
                  ),
                  disabled: !disabledByRole?.AC?.add,
                  isFreeAction: true,
                  onClick: () => history.push('/client-form'),
                },
              ]}
            />
          </>

        </div>
      </div>
    </>
  );
}
